import { connect } from 'react-redux';
import { push, goBack } from 'connected-react-router';
import TreatmentCreateRetroVisit from '../../../features/Treatments/TreatmentCreateRetroVisit';
import {
  getReferral,
  createTreatment,
  getDefaultTimeSlotsPackage,
  createRetrospectiveVisit,
} from '../../../actions/entities';

const mapStateToProps = ({ entities: { referrals, treatments } }) => {
  const { isFetching, referral } = referrals.previewed;
  const { errorMessage } = treatments.previewedTreatment;
  return {
    isFetching,
    referral,
    errorMessage,
  };
};

const mapDispatchToProps = dispatch => ({
  navigate: url => dispatch(push(url)),
  goBack: () => dispatch(goBack()),
  getReferral: id => dispatch(getReferral(id)),
  getDefaultTimeSlotsPackage: () => dispatch(getDefaultTimeSlotsPackage()),
  createTreatment: async treatmentData => await dispatch(createTreatment(treatmentData)),
  createRetrospectiveVisit: retrospectiveVisitData => dispatch(createRetrospectiveVisit(retrospectiveVisitData)),
});

const TreatmentCreateRetroVisitPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TreatmentCreateRetroVisit);

export default TreatmentCreateRetroVisitPage;
